import React from 'react';

export default function TextDisplay({ value = '--' }) {
  return value.split?.('\n').map((text: string, index: number) => {
    // 替换空格
    text = text.replace(/ /g, '\u00a0');
    return (
      <React.Fragment key={index}>
        <span>{`${text}`}</span>
        <br />
      </React.Fragment>
    );
  })
}